module.exports = (__webpack_require__("dll-reference react1702"))(935);